import React from "react";
import { motion } from "framer-motion";

export default function ComingSoon() {
  return (
    <div className="flex flex-col items-center justify-center min-h-screen bg-gradient-to-b from-theme-purple to-white text-center px-4">
      
      {/* Animated text */}
      <motion.h1
        initial={{ opacity: 0, y: -30 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.8, type: "spring" }}
        className="text-5xl md:text-7xl font-extrabold text-white drop-shadow-lg"
      >
        Coming Soon
      </motion.h1>

      {/* Animated subtext */}
      <motion.p
        initial={{ opacity: 0 }}
        animate={{ opacity: 1 }}
        transition={{ delay: 0.6, duration: 0.8 }}
        className="mt-6 text-lg md:text-2xl text-gray-700"
      >
        We are working hard to bring something amazing!
      </motion.p>

      {/* Bouncing dots animation */}
      <div className="flex space-x-2 mt-8">
        {[0, 1, 2].map((i) => (
          <motion.span
            key={i}
            className="w-3 h-3 md:w-4 md:h-4 bg-theme-purple rounded-full"
            animate={{
              y: [0, -10, 0],
            }}
            transition={{
              repeat: Infinity,
              duration: 0.6,
              delay: i * 0.2,
              ease: "easeInOut",
            }}
          />
        ))}
      </div>
    </div>
  );
}
